import { LocalOperationService } from './../../../../service/localOperation.service';
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { OperationService } from 'src/app/demo/service/operation.service';
import { WebStorage } from '../../../auth/storage/web.storage';
import { ITEMS_PER_PAGE } from 'src/app/demo/constants/pagination.constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import * as moment from 'moment';
import { Common } from 'src/app/demo/utils/common';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent {
    userData: any;
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 25,
        totalItems: 0,
        sort: 'id,asc',
    };
    roomList: RoomDTO[] = [];
    roomObj: RoomDTO = {};
    designationList: MasterLookupDTO[] = [];
    selectedRoomId: any;
    selectedDesignation: any;
    selectedStatus: any;
    staffList: StaffDTO[] = [];
    selectAllStaff: boolean = false;
    selectedStaff: any[] = [];
    selectedStudentIds: number[] = [];
    selectedStaffList: any[] = [];
    actualStaffList: StaffDTO[] = [];
    staffSearchInput: any;
    submitForm: boolean = false;
    items!: MenuItem[];
    activeIndex: number = 0;
    profileBgColor: string[] = [];
    selectedDate: any = Common.momentTimeZoneDate(new Date());
    staffSignIn!: FormGroup;
    fromOverView: boolean = false;
    presentStaffIds: any[] = [];
    staffObj: StaffDTO = {};
    isFullAccess: boolean = false;
    today: string = Common.momentTimeZoneDate(new Date());


    constructor(
        private lookupService: LookupService,
        private operationService: OperationService,
        private storage: WebStorage,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private confirmationService: ConfirmationService
    ) {
        this.roomObj = this.config.data;
        this.profileBgColor = profielBackgroundColor;
        this.activeIndex = this.config.data.activeIndex;
        this.fromOverView = this.config.data.fromOverView ? true : false;
        this.selectedStaff = this.fromOverView ? this.config.data.selectedStaffs : [];
        this.selectedStaffList = this.fromOverView ? this.config.data.selectedStaffs : [];
        this.presentStaffIds = this.config.data.presentStaffIds;
        this.selectedStudentIds = this.config.data.selectedStaffIds;
    }

    ngOnInit(): void {
        this.userData = this.storage.getUserData();
        const currentTime24hr = Common.momentTimeZoneTime(new Date());
        const currentDate = Common.momentTimeZoneDate(new Date());
        this.isFullAccess = this.storage.hasAnyAuthority(['Staff Attendance (Full Access)']);
        this.items = [
            {
                label: 'Select Staff',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        summary: 'First Step',
                        key: 'message',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
            {
                label: 'Confirm Staff',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        key: 'message',
                        summary: 'Second Step',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
        ];
        this.staffSignIn = this.formBuilder.group({
            id: [''],
            signInTime: [currentTime24hr],
            signOutTime: [''],
            attendedTime: [''],
            signInBy: [''],
            signOutBy: [''],
            note: [''],
            hasSignIn: [true],
            date: [currentDate],
            roomId: [''],
            staffName: [''],
            status: 'A',
            schoolId: [''],
            hasStudentId: [''],
        });
        this.lookupService.getStaffById(this.userData.refTableId).subscribe((res: HttpResponse<StaffDTO>) => {
            this.staffObj = res.body || {};
            this.queryData();
        });
        this.getRoomData();
        this.getDesignationData();

        this.staffSignIn.get('date')?.valueChanges.subscribe((val: string) => {
            if (!val) return;

            const today = moment().startOf('day');
            const selected = moment(val, 'YYYY-MM-DD').startOf('day');

            if (selected.isAfter(today)) {
                this.staffSignIn.get('date')?.setValue(today.format('YYYY-MM-DD'));
            }
        });
    }

    onActiveIndexChange(event: number) {
        this.activeIndex = event;
    }

    complete() {
        if (this.selectedStudentIds.length != 0) {
            this.activeIndex = 1;
        } else {
            this.activeIndex = 0;
        }
    }

    prevPage() {
        this.activeIndex = 0;
    }
    isButtonDisabled = false;
    onSave() {
        this.isButtonDisabled = true;
        if (this.staffSignIn.valid) {
            if (Array.isArray(this.selectedStaffList)) {
                const selectedStaffId = this.selectedStaffList
                    .map((item: StaffDTO) => item.id)
                    .join(',');
                const unexpectedStaffs = this.selectedStaffList.filter((staff: StaffDTO) => {
                    return staff.isExpectedToday == false;
                });
                const formatTo12Hour = (time: string): string => {
                    if (!time) return ''; // Handle undefined or null cases
                    const [hours, minutes] = time.split(':'); // Extract hours and minutes
                    let hour = parseInt(hours, 10);
                    const ampm = hour >= 12 ? 'PM' : 'AM';
                    hour = hour % 12 || 12; // Convert 0/24 to 12
                    return `${hour
                        .toString()
                        .padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
                };
                const attendanceData: any = {
                id: this.staffSignIn.value.id,
                signInTime: this.staffSignIn.value.signInTime
                    ? formatTo12Hour(this.staffSignIn.value.signInTime)
                    : undefined,
                signOutTime: undefined,
                attendedTime: this.staffSignIn.value.attendedTime,
                signInBy: this.userData.firstName,
                signOutBy: undefined,
                note: this.staffSignIn.value.note,
                hasSignIn: true,
                date: Common.convertLocalDateToUTC(this.staffSignIn.value.date),
                status: 'A',
                schoolId: this.userData.schoolId,
                hasStudentId: false,
                isPrimary: true,
                };

                if (unexpectedStaffs.length > 0) {
                    const unexpectedStudentNames = unexpectedStaffs.map(staff => staff.name);
                    this.ref.close({ openExpected: true, unexpectedStudentNames, attendanceData, selectedStaffId });
                } else {
                    this.operationService
                        .createAttendanceAll(attendanceData, selectedStaffId)
                        .subscribe(
                            (res: HttpResponse<AttendanceDTO>) => {
                                this.selectedStaffList = [];
                                const messages = {
                                    severity: 'success',
                                    life: 3000,
                                    summary: 'Success',
                                    detail: `Staff Signed In successfully.`,
                                };
                                this.submitForm = false;
                                this.ref.close(messages);
                                this.isButtonDisabled = false;
                            },
                            (error) => {
                                this.messageService.add({
                                    severity: 'error',
                                    life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
                                });
                                
                                this.isButtonDisabled = false;
                            }
                        );
                }
            }
        }
    }

    queryData() {
        this.search['profileStatus.equals'] = 'A';
        this.search['status.equals'] = 'A';

        const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
        this.search['date.greaterThanOrEqual'] = startUtc;
        this.search['date.lessThanOrEqual'] = endUtc;
        
        this.search['name.contains'] = this.staffSearchInput;
        this.search['roomId.equals'] = this.selectedRoomId;
        this.search['designation.in'] = this.selectedDesignation;
        this.search['staffId.notIn'] = this.presentStaffIds;
        this.search['size'] = 100;
        this.search['sort'] = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['designation.notEquals'] = 'Kiosk';
        // if (this.staffObj && this.staffObj?.designation != 'Admin' && this.staffObj?.designation != 'Director') {
        //     this.search['staffId.equals'] = (this.staffObj?.designation == 'Admin' || this.staffObj?.designation == 'Director') ? 
        //     undefined : this.userData.refTableId;
        // }
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryAttendanceStaff(this.search)
            .subscribe(async (res: HttpResponse<StaffDTO[]>) => {
                let temp: StaffDTO[] = [];
                this.staffList = res.body ? res.body : temp;
                this.actualStaffList = this.staffList;
                for (const staff of this.staffList) {
                    if (staff) {
                    //     this.selectedStaffList.forEach((res: StaffDTO) => {
                    //         if (res.id == staff.id) {
                    //             staff.selected = res.selected;
                    //         }
                    //     }
                    // );
                        if (staff.photoUuid) {
                            this.lookupService
                                .queryDocumentByPhotoUid(staff.photoUuid)
                                .subscribe((response: HttpResponse<Blob>) => {
                                    const body = response?.body;
                                    if (body) {
                                        const url =
                                            this.createImgFromBuffer(body);
                                        staff.profileimg = url;
                                    }
                                });
                        } else {
                            staff.profileimg = undefined;
                        }
                    }
                }
            });
    }

    getRoomData() {
        this.search = {};
        this.search['sort'] = 'name,asc';
        this.search['status.equals'] = 'A';
        this.search['id.notEquals'] = this.roomObj.id;
        this.search.size = 500;
        this.search['schoolId.equals'] = this.userData.schoolId;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
            });
    }

    getDesignationData() {
        this.lookupService
            .queryMasterLookups({
                'schoolId.equals': this.userData.schoolId,
                'type.equals': 'Designation',
                'name.notEquals': 'Kiosk',
                'status.equals': 'A',
            })
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.designationList = res.body ? res.body : temp;
            });
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }

    onClear() {
        this.staffSearchInput = [];
        this.selectedRoomId = undefined;
        this.selectedDesignation = [];
        this.actualStaffList = [];
        this.selectedStaffList=[];
        this.selectedStudentIds = [];
        this.selectAllStaff = false;
        this.selectedStatus = [];
        this.selectedStudentIds = [];
        this.filter();
        this.filterRoom();
        this.filterDesig();
        this.queryData();
    }

    filter() {
        let filtered: StaffDTO[] = [];

        if (this.staffSearchInput.length !== 0) {
            for (let i = 0; i < this.staffList.length; i++) {
                let user = this.staffList[i];
                if (
                    user?.name &&
                    (user.name
                        .toLowerCase()
                        .indexOf(this.staffSearchInput.toLowerCase()) === 0 ||
                        user.name
                            .toLowerCase()
                            .includes(this.staffSearchInput.toLowerCase()))
                ) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStaffList];
        }

        this.staffList = [...filtered];
        this.checkboxChanged();
    }

    filterRoom() {
        let filtered: StaffDTO[] = [];
        if (this.selectedRoomId != undefined) {
            for (let i = 0; i < this.actualStaffList.length; i++) {
                let user = this.actualStaffList[i];
                if (
                    user?.primaryRoomId &&
                    user.primaryRoomId == this.selectedRoomId
                ) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStaffList];
        }

        this.staffList = [...filtered];
        this.checkboxChanged();
    }
    filterDesig() {
        let filtered: StaffDTO[] = [];
        if (this.selectedDesignation.length == 0) {
            filtered = [...this.actualStaffList];
        } else {
            // Create a Set for more efficient lookup
            const selectedTagSet = new Set(this.selectedDesignation);

            filtered = this.actualStaffList.filter(
                (user) =>
                    user?.designation && selectedTagSet.has(user.designation)
            );
        }
        this.staffList = [...filtered];
        this.checkboxChanged();
    }

    onRemoveStaff(event: Event, staff: any) {
        this.confirmationService.confirm({
            key: 'confirm2',
            target: event.target as EventTarget,
            message: `Do you want to Remove ${staff.name}?`,
            acceptButtonStyleClass: 'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
            defaultFocus: 'none',
            accept: () => this.deleteStaff(staff),
            reject: () => { },
        });
    }

    deleteStaff(staff: any) {
        try {
            if (!staff || !staff.id) {
                throw new Error('Invalid staff data');
            }

            if (!this.selectedStaffList || !this.selectedStudentIds || !this.selectedStaff || !this.staffList) {
                throw new Error('Required arrays are not initialized');
            }

            this.selectedStaffList = this.selectedStaffList.filter(
                (item) => item.id !== staff.id
            );

            this.selectedStudentIds = this.selectedStudentIds.filter(
                (id) => id !== staff.id
            );

            this.selectedStaff = this.selectedStaff.filter(
                (item) => item.id !== staff.id
            );

            const mainListStaff = this.staffList.find(
                (item) => item.id === staff.id
            );
            if (mainListStaff) {
                mainListStaff.selected = false;
            }

            this.selectAllStaff = false;
            this.submitForm = false;

            // Show success message
            this.messageService.add({
                key: 'message',
                severity: 'success',
                life: 3000,
                summary: 'Success',
                detail: 'Staff Removed Successfully'
            });

        } catch (error) {
            console.error('Error in deleteStaff:', error);
            this.messageService.add({
                key: 'message',
                severity: 'error',
                life: 3000,
                summary: 'Error',
                detail: (error as Error).message || 'Failed to remove staff'
            });
        }
    }

    toggleSelection(staff: any) {
        const index = this.selectedStaff.findIndex(
            (selected) => selected.id === staff.id
        );
        if (index !== -1) {
            this.selectedStaff.splice(index, 1);
        } else {
            this.selectedStaff.push(staff);
        }
        this.selectedStudentIds = this.selectedStaff.map(
            (selected) => selected.id
        );

        this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
            this.selectedStudentIds.includes(item.id as number)
        );
    }

    isSelected(staff: StaffDTO): boolean {
        return this.selectedStaff.includes(staff);
    }

    toggleAllSelection() {
        this.staffList.forEach(
            (staff) => (staff.selected = this.selectAllStaff)
        );

        if (this.selectAllStaff) {
            this.selectedStaff = [...this.staffList];
        } else {
            this.selectedStaff = [];
        }
        this.selectedStudentIds = this.selectedStaff.map(
            (selected) => selected.id
        );

        this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
            this.selectedStudentIds.includes(item.id as number)
        );
    }

    checkboxChanged() {
        if (this.staffList && this.staffList?.length !== 0) {
            if (this.isAllSelected()) this.selectAllStaff = true;
            else this.selectAllStaff = false;
        } else {
            this.selectAllStaff = false;
        }
    }

    isAllSelected(): boolean {
        return this.staffList.every((staff) => staff.selected);
    }

    private patchDateValue(dateValue: any): string {
        let formattedDate;
        // Check if the value is a valid date before formatting
        if (dateValue && !isNaN(new Date(dateValue).getTime())) {
            formattedDate = Common.convertLocalDateToUTC(dateValue)
        } else {
            // If the value is not a valid date, set it to null or handle it accordingly
            formattedDate = '';
        }
        return formattedDate;
    }

    getBackgroundColor(roomId: number): string {
        if (!roomId) return this.profileBgColor[0];
        const index = (roomId - 1) % this.profileBgColor.length;
        return this.profileBgColor[index];
    }

    getInitials(name: string): string {
        const words = name.trim().split(/[-\s]+/); // Split by hyphens or spaces
        const firstLetter = words[0][0]?.toUpperCase(); // Get the first letter of the first word
        const secondLetter = words[1]?.[0]?.toUpperCase() || ''; // Get the first letter of the second word (if it exists)
        return `${firstLetter}${secondLetter}`.trim(); // Concatenate and trim
    }

    getAttenStatus(staff: any) {
        if (staff?.isSignedIn) {
            return 'Staff is signed in';
        } else if (staff?.isAbsent) {
            return 'Staff is absent';
        } else if (staff?.profileStatus == 'Upcoming') {
            return 'Staff is upcoming';
        } else if (staff?.profileStatus == 'I') {
            return 'Staff is inactive';
        }
        return '';
    }
}
